// extracted by mini-css-extract-plugin
module.exports = {"rating":"Rating_rating__rRyMY","star":"Rating_star__ELzuE","filled":"Rating_filled__Ts_NW","skeleton":"Rating_skeleton__wpW7n"};